var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7281 20.3888C11.6451 20.3838 7.73112 18.7598 4.84412 15.8728C1.95712 12.9858 0.333125 9.07179 0.328125 4.98879C0.328125 3.76879 0.81311 2.59877 1.67511 1.73577C2.53811 0.873772 3.70813 0.388787 4.92813 0.388787C5.18613 0.386787 5.44412 0.410795 5.69812 0.458795C5.94312 0.494795 6.18412 0.555787 6.41812 0.638787C6.58212 0.696787 6.72914 0.795789 6.84314 0.927789C6.95714 1.05879 7.03412 1.21779 7.06812 1.38879L8.43811 7.38879C8.47511 7.55179 8.47011 7.7208 8.42511 7.8818C8.38011 8.0428 8.29513 8.1898 8.17813 8.3088C8.04813 8.4488 8.03814 8.45878 6.80814 9.09878C7.79314 11.2598 9.52113 12.9948 11.6781 13.9888C12.3281 12.7488 12.3381 12.7388 12.4781 12.6088C12.5971 12.4918 12.7441 12.4068 12.9051 12.3618C13.0661 12.3168 13.2351 12.3118 13.3981 12.3488L19.3981 13.7188C19.5631 13.7568 19.7161 13.8368 19.8421 13.9508C19.9681 14.0648 20.0631 14.2088 20.1181 14.3688C20.2021 14.6058 20.2661 14.8508 20.3081 15.0988C20.3481 15.3498 20.3681 15.6048 20.3681 15.8588C20.3501 17.0738 19.8511 18.2318 18.9821 19.0808C18.1131 19.9288 16.9431 20.3998 15.7281 20.3888Z",
    fill: "#2266EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1e536b8cd83e65af0b9ab6142f329c32.svg";
export { ForwardRef as ReactComponent };